"use client";

import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
const LOGO_SRC = "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/logoblack.png";
const navItems = [{
  label: "Course Finder",
  to: "/course-finder/"
}, {
  label: "Course Intelligence",
  to: "/course-intelligence/"
}, {
  label: "Destinations",
  to: "/#home-destinations"
}, {
  label: "Golf Travel Guides",
  to: "/blog/"
}, {
  label: "Golf Passport",
  to: "/#home-golf-passport"
}, {
  label: "Partner With Us",
  to: "/teelistclub-landing/"
}];
export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [logoFailed, setLogoFailed] = useState(false);
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isMobileMenuOpen]);
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  return <header id="header" data-section-id="259734" className={["fixed inset-x-0 top-0 z-[100] w-full", "m-0 border-b border-white/10 p-0", "bg-[#073F31]", "shadow-[0_5px_18px_rgba(0,0,0,0.12)]"].join(" ")} style={{
    fontFamily: '"Raleway", Arial, sans-serif'
  }}>
      <div className={["relative mx-auto w-full", "h-[86px] min-h-[86px]", "max-w-[1600px]", "px-6 lg:px-10 xl:px-12", "flex items-center justify-between", "lg:grid", "lg:grid-cols-[205px_minmax(0,1fr)_205px]", "lg:items-center"].join(" ")}>
        {/* Logo */}
        <Link to="/" aria-label="TeeListClub homepage" className={["relative flex h-full shrink-0 items-center", "lg:justify-self-start"].join(" ")}>
          {!logoFailed ? <img src={LOGO_SRC} alt="TeeListClub" onError={() => setLogoFailed(true)} className={["block h-auto object-contain", "w-[154px] sm:w-[162px]", "lg:w-[176px] xl:w-[184px]"].join(" ")} style={{
          filter: "brightness(1.18) saturate(1.05) drop-shadow(0 2px 7px rgba(255,253,247,0.16))"
        }} /> : <WvcLogo className="h-[44px] w-auto" />}
        </Link>

        {/* Desktop navigation */}
        <nav aria-label="Primary navigation" className={["hidden h-full min-w-0", "lg:flex lg:w-full", "lg:max-w-[1000px]", "lg:items-center", "lg:justify-between", "lg:justify-self-center", "lg:px-4 xl:px-6"].join(" ")}>
          {navItems.map(item => <Link key={item.label} to={item.to} className={["group relative", "inline-flex h-full items-center justify-center", "m-0 p-0", "whitespace-nowrap", "text-[9px] xl:text-[10px]", "font-semibold uppercase", "tracking-[0.095em]", "leading-none", "text-[#FFFDF7]/88", "no-underline", "transition-colors duration-200", "hover:text-[#FFFDF7]"].join(" ")}>
              <span className="relative inline-flex items-center leading-none">
                {item.label}

                <span className={["absolute -bottom-[10px] left-0 right-0", "h-px origin-left scale-x-0", "bg-[#BFFF00]", "transition-transform duration-200", "group-hover:scale-x-100"].join(" ")} />
              </span>
            </Link>)}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden h-full items-center justify-self-end lg:flex">
          <Link to="/join-teelistclub/" className="inline-flex min-h-[46px] w-[176px] min-w-[176px] items-center justify-center rounded-[8px] bg-[#BFFF00] px-5 text-[10px] font-bold uppercase tracking-[0.075em] leading-none text-[#073F31] no-underline shadow-[0_6px_18px_rgba(191,255,0,0.16)] transition duration-200 hover:-translate-y-px hover:bg-[#C8FF35]">
            Join TeeListClub
          </Link>
        </div>

        {/* Mobile menu control */}
        <button type="button" aria-label={isMobileMenuOpen ? "Close navigation menu" : "Open navigation menu"} aria-expanded={isMobileMenuOpen} aria-controls="mobile-navigation" onClick={() => setIsMobileMenuOpen(current => !current)} className={["flex size-10 items-center justify-center", "rounded-[8px]", "border border-white/20", "bg-white/[0.08]", "text-[#FFFDF7]", "transition", "hover:border-[#BFFF00]/60", "hover:text-[#BFFF00]", "lg:hidden"].join(" ")}>
          {isMobileMenuOpen ? <X className="size-5" strokeWidth={1.8} /> : <Menu className="size-5" strokeWidth={1.8} />}
        </button>
      </div>

      {/* Mobile navigation */}
      {isMobileMenuOpen && <div id="mobile-navigation" className={["border-t border-white/10", "bg-[#073F31]", "px-5 pb-7 pt-4", "shadow-2xl", "sm:px-8 lg:hidden"].join(" ")}>
          <nav aria-label="Mobile navigation" className="mx-auto flex max-w-[720px] flex-col">
            {navItems.map(item => <Link key={item.label} to={item.to} onClick={closeMobileMenu} className={["flex min-h-[54px] items-center", "border-b border-white/10", "py-4", "text-[13px] font-semibold uppercase", "tracking-[0.1em]", "leading-none", "text-[#FFFDF7]/88", "no-underline", "transition hover:text-[#BFFF00]"].join(" ")}>
                {item.label}
              </Link>)}

            <Button asChild className={["mt-6 h-[50px] w-full", "rounded-[8px]", "bg-[#BFFF00]", "text-[13px] font-bold uppercase", "tracking-[0.08em]", "text-[#073F31]", "hover:bg-[#C8FF35]"].join(" ")}>
              <Link to="/join-teelistclub/" onClick={closeMobileMenu}>
                Join TeeListClub
              </Link>
            </Button>
          </nav>
        </div>}
    </header>;
}